/* Small helpers shared across HQ pages. */

/** Turn an axios error into a readable string for toast.error.
 *  FastAPI 422 returns detail = [{msg, loc, ...}], never pass that to React. */
export function errMsg(err, fallback = "Something went wrong.") {
  const d = err?.response?.data?.detail;
  if (typeof d === "string") return d;
  if (Array.isArray(d)) return d.map((x) => x?.msg || JSON.stringify(x)).join("; ");
  if (d && typeof d === "object") return d.msg || JSON.stringify(d);
  return err?.message || fallback;
}
